/* Marketing visit beacon: one hit per browser session, source from ?src= / ?utm_source= (facebook, whatsapp, qr…) else "direct".
   No personal data — just source, landing path, device class and referrer host. */
export const trackVisit = () => {
  try {
    if (sessionStorage.getItem("rl_visit_sent")) return;
    const qs = new URLSearchParams(window.location.search);
    const src = (qs.get("src") || qs.get("utm_source") || "direct").toLowerCase().slice(0, 30);
    let ref = "";
    try { ref = document.referrer ? new URL(document.referrer).hostname.slice(0, 60) : ""; } catch {}
    const body = JSON.stringify({ src, path: window.location.pathname.slice(0, 80), device: /Mobi|Android/i.test(navigator.userAgent) ? "mobile" : "desktop", ref });
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/track/visit`;
    if (!(navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: "application/json" })))) {
      fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
    }
    sessionStorage.setItem("rl_visit_sent", "1");
  } catch { /* ignore */ }
};
